import * as type from '../actions/types';

const initialState = {
  completedRegsteps:false,
  registration: [],
  loading: false,
  error: null,
}

export default function registerBusiness(state = initialState, action) {
  switch (action.type) {
    case type.POST_REGISTER_BUSINESS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: null, // Clear any previous errors when starting a new request
      }
    case type.POST_REGISTER_BUSINESS_SUCCESS:
      return {
        ...state,
        loading: false,
        registration: action.registerBusiness,
        completedRegsteps:true
        // error:action.errors
      }
    case type.POST_REGISTER_BUSINESS_FAILED:
      return {
        ...state,
        completedRegsteps:0,
        loading: false,
        error: action.message,
      }
    default:
      return state
  }
}